import { of, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { State } from '../services/work.state';

export const scriptDisable = () =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (!state.system?.scriptDisable)
        return of([state, currentState] as [Partial<State>, State]);

      const newState = {
        ...state,
        ...{
          scriptDisable: state.system?.scriptDisable,
          system: {
            ...state.system,
            ...{
              scriptDisable: undefined,
            },
          },
        },
      };
      return of([newState, currentState] as [Partial<State>, State]);
    })
  );
